import { EntityDefinition } from '@/types/crud';

export const riskCategoryEntity: EntityDefinition = {
  name: 'riskCategories',
  displayName: 'Risk Categories',
  displayNameSingular: 'Risk Category',
  apiEndpoint: '/generic/risk_categories',
  idField: 'id',
  nameField: 'name',
  copyable: true,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'name',
      label: 'Category Name',
      type: 'text',
      required: true,
      placeholder: 'Enter category name',
      order: 1
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      placeholder: 'Enter category description',
      order: 2
    },
    {
      key: 'color_code',
      label: 'Color Code',
      type: 'text',
      placeholder: 'Enter color code (e.g., #FF5733)',
      order: 3
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'checkbox',
      defaultValue: true,
      order: 4
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      hidden: true,
      order: 5
    },
    {
      key: 'updated_at',
      label: 'Updated',
      type: 'datetime',
      hidden: true,
      order: 6
    },
    {
      key: 'tenant_id',
      label: 'Tenant ID',
      type: 'text',
      hidden: true,
      order: 7
    }
  ],
  tableColumns: [
    {
      key: 'name',
      label: 'Category Name',
      sortable: true
    },
    {
      key: 'description',
      label: 'Description',
      sortable: true
    },
    {
      key: 'color_code',
      label: 'Color',
      sortable: true
    },
    {
      key: 'is_active',
      label: 'Active',
      sortable: true
    },
    {
      key: 'created_at',
      label: 'Created',
      sortable: true
    }
  ],
  searchFields: ['name', 'description'],
  defaultSort: { field: 'name', direction: 'asc' }
};